import PropTypes from 'prop-types';

import { HamburgerLine, HamburgerWrapper } from './Hamburger.styled';

export function Hamburger({ isToggled, onClick }) {
  return (
    <HamburgerWrapper
      onClick={onClick}
      type="button"
    >
      <HamburgerLine
        $isTop
        $isToggled={isToggled}
      />
      <HamburgerLine $isToggled={isToggled} />
    </HamburgerWrapper>
  );
}

Hamburger.propTypes = {
  isToggled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Hamburger;
